module.exports = __webpack_public_path__ + "img/news1-5.c74cb140.png";